import { OUTLETS } from "@/sections/InTheNews";

export default function FeaturedIn() {
  return (
    <a
      href="/#news"
      data-testid="featured-in-strip"
      aria-label="As featured in national financial media — jump to press coverage"
      className="group block border-y hairline bg-white/70 backdrop-blur-sm hover:bg-white transition-colors"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-4 md:py-5 flex flex-col md:flex-row md:items-center gap-3 md:gap-8">
        <span className="shrink-0 font-mono-label text-[10px] tracking-[0.2em] uppercase text-[#71747B] group-hover:text-[#0F1117] transition-colors">
          / As Featured In
        </span>
        <div className="flex flex-wrap items-center gap-x-6 gap-y-2 md:justify-between md:flex-1">
          {OUTLETS.map((outlet) => (
            <span
              key={outlet.name}
              data-testid={`featured-in-${outlet.name.toLowerCase().replace(/\s+/g, "-")}`}
              className="inline-flex items-center gap-2 whitespace-nowrap"
            >
              <img
                src={`https://www.google.com/s2/favicons?domain=${outlet.domain}&sz=64`}
                alt=""
                aria-hidden
                loading="lazy"
                className="w-4 h-4 object-contain opacity-80 group-hover:opacity-100 transition-opacity"
                onError={(e) => {
                  e.currentTarget.style.display = "none";
                }}
              />
              <span className="text-chrome font-display text-sm md:text-base font-extrabold tracking-tight">
                {outlet.name}
              </span>
            </span>
          ))}
        </div>
      </div>
    </a>
  );
}
